export class ZopimHandler {
  public setUser({ name, email }: { name: string; email: string }) {
    (window as any).$zopim(() => {
      (window as any).$zopim.livechat.set({
        name,
        email,
      });
    });
  }

  public clearAll() {
    (window as any).$zopim(() => {
      (window as any).$zopim.livechat.clearAll();
    });
  }

  public hideAll() {
    (window as any).$zopim(() => {
      (window as any).$zopim.livechat.hideAll();
    });
  }

  public show() {
    (window as any).$zopim(() => {
      (window as any).$zopim.livechat.window.show();
    });
  }

  public minimize() {
    (window as any).$zopim(() => {
      (window as any).$zopim.livechat.window.hide();
    });
  }

  public addTags(tag: string) {
    (window as any).$zopim(() => {
      (window as any).$zopim.livechat.addTags(tag);
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/infrastructure/adapter/ZopimHandler.ts